import '../css_styles/button_styles.css'
import '../css_styles/window_canvas_styles.css'

// imports relevant for HTTP calls
import DisplayException from '../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import { SERVER_URL } from '../config_server_url';

// ----- Imports for main window --------s
import ObjectiveTableViewer from './ObjectiveTableViewer';
import PlotSubobjective from './PlotSubobjective';
import ScoringWeightsTableEditor from './ScoringWeightsTableEditor'

import UserSessionContext from '../user_session/context_user_session';
import { useContext, useState, useEffect } from 'react';

function ObjectiveViewer(props) {

    const usr_session_ctx = useContext(UserSessionContext);
    const [isLoading, setIsLoading] = useState(false);
    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    
    // ------------------ General Window Layout -----------------------------

    const[objectives, setObjectives] = useState([]);
    const[scoringType, setScoringType] = useState('');
    const[title, setTitle] = useState('');

    // ------------------ Display Object Validation Information/Warnings/Errors  ---------------------------------
    const [validated, setValidated] = useState(true);
    
    // --- states do handle plots of subobjectives
    const [svgUrlsPlots, setSvgUrlsPlots] = useState([])

    // Clean up Blob URLs for plotting the subobjectives on unmounting the component
    // This also has the effect that on Enter Workflow Editor all images will be lost.
    useEffect(() => {
        return () => {
            // Clean up the Blob URL when the component unmounts
            svgUrlsPlots.forEach((svg_url, id) => {
                if(svg_url !== '') {
                    URL.revokeObjectURL(svg_url);
                }
            });
        };
    });

    useEffect( () => {
        if(typeof props.validated !== 'undefined'){ setValidated(props.validated); }
        else { setValidated(false); }
        }, []);



    // Load Objectives
    useEffect( () => {
        setIsLoading(true);
        if (props.campaign_objects.uuid_objective !== '') {
            const fetchObjective = async () => {
                    setIsLoading(true);
                    const uuid_objective = props.campaign_objects.uuid_objective;
                try {
                    const response = await fetch(`${SERVER_URL}/current_project/load_objective/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'uuid_tenant': usr_session_ctx.uuid_tenant
                        },
                        body: JSON.stringify(uuid_objective),
                    });
        
                    if (!response.ok) {
                        throw new Error(`HTTP error ${response.status}`);
                    }
        
                    const data = await response.json();
                    const valid_responses = await initial_validation_responses(data.data.objectives);
                    const urls_plots = await initialize_plots(valid_responses, data.data.objectives);
                    setSvgUrlsPlots(urls_plots);
                    setObjectives(data.data.objectives);
                    setTitle(data.data.title);
                    setScoringType(data.data.scoring_type);
                } catch (err) {
                    setException(true);
                    setExceptionMessage(`HTTPException: err_msg=${err.message}`);
                } 
            };
            fetchObjective();
            setIsLoading(false);
        }
    }, [props.campaign_objects.uuid_objective]);

    
    async function initial_validation_responses(data_objectives) {
        setIsLoading(true);
        let is_valid = []
        try{
            let headers = {
                'Content-Type': 'application/json'
            };
            const response = await fetch(`${SERVER_URL}/current_project/initial_validation_all_subobjectives/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(data_objectives)
            });
            if(response.ok){
                const data = await response.json();
                is_valid = data.data;
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
        }
        catch(err) {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
        setIsLoading(false);
        return is_valid;
    }


    // Plot SubObjective
    async function initialize_plots(valid_objectives, data_objectives){
        setIsLoading(true);
        let urls_plots = data_objectives.map( () => ('') );
        try{
            let objectives = {is_valid: valid_objectives, data_objectives: data_objectives}
            let headers = {
                'Content-Type': 'application/json'
            };
            const response = await fetch(`${SERVER_URL}/current_project/plot_all_subobjectives/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(objectives)
            });
            if(response.ok){
                const data = await response.json();
                const svg_plots = data.data;
                svg_plots.forEach((svg_plot, id) => {
                    if(svg_plot !== ''){
                        const blob = new Blob([svg_plot], { type: 'image/svg+xml' });
                        const svg_url = URL.createObjectURL(blob);
                        urls_plots[id] = svg_url;
                    }
                });
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
        }
        catch(err) {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
        setIsLoading(false);
        return urls_plots;
    }

    // Note if F12 open developer toolbox react sometimes unmounts the component -> we loose our SVGUrls which can affect the function downloadPNGs
    function downloadPNGs() {
        let subscore_names = []
        subscore_names = objectives.map ( (subscore) => {
            if(subscore.is_score === true) { 
                return subscore.name
            }
            else {
                return undefined
            }
        });

        svgUrlsPlots.forEach((url, index) => {
            if (url !== '') {
                // Create an image element
                const image = new Image();
                image.src = url;
                image.onload = () => {
                    // Create a canvas element
                    const canvas = document.createElement('canvas');
                    canvas.width = image.width;
                    canvas.height = image.height;
    
                    // Draw the image on the canvas
                    const context = canvas.getContext('2d');
                    context.drawImage(image, 0, 0, image.width, image.height);
    
                    // Convert the canvas to a PNG blob
                    canvas.toBlob((blob) => {
                        // Create a download link
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        // link.download = `image_${index + 1}.png`;
                        link.download = `subscore_${subscore_names[index]}.png`;
    
                        // Trigger the download
                        link.click();
    
                        // Clean up
                        URL.revokeObjectURL(link.href);
                    }, 'image/png');
                };
            }
        });
    }




 
    let plot_objectives = (<></>)
    if(objectives.length >0)
        {
            plot_objectives = (<PlotSubobjective  svgUrls={svgUrlsPlots} 
                                                  plots_per_row={3} 
                                                  objectives={objectives}
                                                  onDownloadPNGs={downloadPNGs}
                                                  enable_export={true}/>);
    }

    let total_score = (<></>)
    if(scoringType === 'Multiplicative') {
        let isMultiplicative = true
        let isAdditive = false
        total_score = (<>
                    <h4 style = {{margin:'0px', marginTop:'10px', marginLeft:'10px', marginBottom:'5px', width:'fit-content'}} >
                        Total Score 
                    </h4>
                    <div style = {{display:'flex', fontSize:'14px', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'5px', height:'fit-content', width:'95%'}}>
                        <div style={{marginRight:'5px', width:'20px', height: '20px', display:'flex', justifyContent: 'center', alignItems:'center'}}>  
                            <input type="radio" name="total_score" value="Multiplicative" checked={isMultiplicative} />
                        </div>
                        <div><strong>multiplicative: </strong> Use when a low individual sub-score should result in a low total score.</div>
                    </div>

                    <div style = {{display:'flex', fontSize:'14px', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'5px', height:'fit-content', width:'95%'}}>
                        <div style={{marginRight:'5px', width:'20px', height: '20px', display:'flex', justifyContent: 'center', alignItems:'center'}}>
                            <input type="radio" name="total_score" value="Additive" checked={isAdditive}  />
                        </div>
                        <div><strong>additive: </strong> Use when a low individual sub-scores can be offset by high other sub-scores.</div>
                    </div>
                </>);
    }
    if(scoringType === 'Additive') {
        let isMultiplicative = false
        let isAdditive = true
        total_score = (<>
            <h4 style = {{margin:'0px', marginTop:'10px', marginLeft:'10px', marginBottom:'5px', width:'fit-content'}} >
                Total Score 
            </h4>
            <div style = {{display:'flex', fontSize:'14px', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'5px', height:'fit-content', width:'95%'}}>
                <div style={{marginRight:'5px', width:'20px', height: '20px', display:'flex', justifyContent: 'center', alignItems:'center'}}>  
                    <input type="radio" name="total_score" value="Multiplicative" checked={isMultiplicative} />
                </div>
                <div><strong>multiplicative: </strong> Use when a low individual sub-score should result in a low total score.</div>
            </div>

            <div style = {{display:'flex', fontSize:'14px', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'5px', height:'fit-content', width:'95%'}}>
                <div style={{marginRight:'5px', width:'20px', height: '20px', display:'flex', justifyContent: 'center', alignItems:'center'}}>
                    <input type="radio" name="total_score" value="Additive" checked={isAdditive}  />
                </div>
                <div><strong>additive: </strong> Use when a low individual sub-scores can be offset by high other sub-scores.</div>
            </div>
            <div style = {{display:'flex', fontSize:'14px', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'5px', overflow:'auto', height:'fit-content', width:'95%'}}>
                <div style = {{marginLeft:'25px', fontSize:'14px'}}>
                    If applicable, prioritize sub-scores by giving them higher scoring weights in the total score (default setting: all contribute equally).
                </div>
            </div>   
            <div style = {{display:'flex', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'15px', overflow:'auto', height:'fit-content', width:'95%'}}>
                    <ScoringWeightsTableEditor objectives={objectives} />
            </div>  
            
        </>);

    }


    let viewer = (<></>)
    if(isLoading && !Exception){
        viewer = (<div className = {'builder_canvas'} >
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </div>);
    }

    if(Exception){
        viewer = (<>
                    <div className = {'builder_canvas'} >
                        <DisplayException>
                            {ExceptionMessage}
                        </DisplayException>  
                    </div>
                </>);
    }

    let rquires_validation = <></>
        if(!validated){
            rquires_validation = (<>
                            <div style={{marginLeft:'20px', marginTop:'20px', marginBottom:'10px', display:'flex', justifyItems:'center'}}>
                                <button 
                                    // className={'actionButtonTiny'}
                                    className={'tableButton'}
                                    style={{marginTop:'0px', width:'130px', marginLeft: '0px', marginBottom:'px'}}
                                    onClick={props.onEdit}
                                    >
                                    validate in editor
                                </button>
                                <div style={{margin:'0px', padding:'0px', fontSize:'14px', color:'var(--aixelo-red)'}}>Changes in Experimental Workflow require Objective (re)validation.</div>
                            </div>
                        </>);
        }


    let action_panel = (<></>);
    if(typeof props.hideActionPanel === 'undefined' || !props.hideActionPanel) {
        action_panel = (<>
                <div style={{position: 'relative', display:'flex', marginLeft: '10px', marginTop:'10px', paddingTop:'10px',
                        marginBottom:'0px', height:'fit-content', width:'fit-content'}}>   
                    <button className={'tableButton'} onClick={props.onEdit} style={{width: '95px', paddingBottom: '3px', paddingTop: '3px', marginBottom: '0px'}}>Edit</button>
                    {/* <button className={'tableButton'} style={{marginRight: '10px', width: '95px', paddingBottom: '3px', paddingTop: '3px', marginBottom: '0px'}} >Delete</button>
                    <button className={'tableButton'} style={{width: '95px', paddingBottom: '3px', paddingTop: '3px', marginBottom: '0px'}} >Load</button>
                    <button className={'tableButton'} style={{width: '95px', paddingBottom: '3px', paddingTop: '3px', marginBottom: '0px'}} >Create New</button> */}
                </div>  
            </>);
    }


    if(!isLoading && !Exception){
            viewer = (<>
                        <div className = {'viewer_canvas'} style={{height:props.height-120}}>
                        <p style = {{marginLeft: '20px', marginTop: '10px', marginBottom: '3px', fontSize: '18px', fontWeight:'bold', position: 'relative', width:'94%'}} >
                            Title: {title}
                        </p>
                        <div style = {{marginLeft: '20px', marginTop: '0px', marginBottom: '3px', fontSize: '12px', position: 'relative', width:'fit-content'}} >
                            uuid: {props.campaign_objects.uuid_objective}
                        </div>
                        <div style = {{marginLeft: '20px', marginTop: '0px', marginBottom: '3px', fontSize: '12px', position: 'relative', width:'fit-content'}} >
                            Response names are derived from Experimental Workflow with uuid: {props.campaign_objects.uuid_experimental_setup}
                        </div>
                        {rquires_validation}
                            <div style={{width: `${props.width * 0.91 - 70}px`,  marginTop:'20px', marginLeft:'20px', overflow:'auto'}}>
                                <ObjectiveTableViewer objectives={objectives} />
                            </div> 
                            <div style = {{width: `${props.width * 0.91 - 70}px`, marginLeft: '20px', marginTop: '20px', marginBottom: '20px', border:'0.5px solid var(--aixelo-gray-light)'}}>
                                {total_score}
                            </div>
                            <div style={{width: `${props.width * 0.91 - 70}px`, height:'fit-content', padding:'0px', marginLeft:'20px', marginTop:'15px', marginBottom:'30px', overflow:'auto', border:'solid 0.5px var(--aixelo-gray-light)'}}>
                                {plot_objectives}
                            </div>
                        </div>
                        {action_panel}
                    </>
                    );

    }
    return (<>
                {viewer}
            </>);
}

export default ObjectiveViewer